import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticateGuard, BrowserGuard, ErrorComponent, LoginComponent, PasswordLoginComponent, PasswordLoginGuard } from '@inera/common';
import { LogoutViewComponent } from './view/logout.component';
import { UnsupportedPageComponent } from './view/unsupported-page.component';
@NgModule({
  imports: [
  RouterModule.forRoot([
    {
    path: 'login',
    component: LoginComponent,
    canActivate: [BrowserGuard]
    },
    {
    path: 'passwordlogin',
    component: PasswordLoginComponent,
    canActivate: [PasswordLoginGuard, BrowserGuard]
    },
    {
    path: 'loggedout',
    component: LogoutViewComponent
    },
    {
    path: 'unsupportedpage',
    component: UnsupportedPageComponent
    },
    {
    path: '_error',
    component: ErrorComponent,
    data: { redirect: true }
    },
    {
    path: '',
    loadChildren: () => import('../pdl-log/pdl-log.module').then(m => m.PdlLogModule),
    canActivate: [BrowserGuard, AuthenticateGuard]
    },
    {
    path: '**',
    redirectTo: ''
    }
    ])
  ],
  exports: [
  RouterModule
  ]
  })
export class RoutingModule { }
